"use strict";
/**
 * BODY MAP (fastidi/dolori atleta) — soglie e predicati di dominio.
 *
 * Migrate qui da `apps/backend/src/body-map/{body-map.service,body-map-alert.service}.ts`
 * dove erano letterali hardcoded (viola la regola "soglie di dominio solo nel
 * motore calc"). Comportamento invariato: stesse zone, stessi confini.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.SUGGEST_INJURY_INTENSITY = exports.PERSISTENCE_CONSECUTIVE_DAYS = exports.PERSISTENCE_MIN_INTENSITY = exports.SPREAD_MIN_NEW_ZONES = exports.SPREAD_MIN_ZONES = exports.HIGH_INTENSITY_MIN = exports.HOOPER_SORENESS_ALERT_MIN = exports.COMPLAINT_MIN_INTENSITY = exports.DOMS_ALERT_MIN_INTENSITY = exports.DOMS_CAP_INTENSITY = exports.DOMS_ZONES = void 0;
exports.isDomsZone = isDomsZone;
exports.applyDomsCap = applyDomsCap;
exports.isDomsCapAlert = isDomsCapAlert;
exports.isHighIntensity = isHighIntensity;
exports.isPersistentIntensity = isPersistentIntensity;
exports.suggestsInjuryIntensity = suggestsInjuryIntensity;
// ─── Zone DOMS (Delayed Onset Muscle Soreness) ───────────────────────────────
/**
 * Zone muscolari soggette a DOMS: l'intensità segnalata viene cappata a
 * `DOMS_CAP_INTENSITY` prima del salvataggio (il dolore muscolare post-sforzo
 * non va trattato come un infortunio acuto).
 */
exports.DOMS_ZONES = [
    'quadricep_dx',
    'quadricep_sx',
    'hamstring_dx',
    'hamstring_sx',
    'calf_dx',
    'calf_sx',
    'upper_back',
    'lumbar',
];
const DOMS_ZONE_SET = new Set(exports.DOMS_ZONES);
/** La zona è tra quelle soggette a cap DOMS? */
function isDomsZone(zone) {
    return DOMS_ZONE_SET.has(zone);
}
/** Intensità massima salvata per una zona DOMS (oltre viene cappata qui). */
exports.DOMS_CAP_INTENSITY = 3;
/**
 * Applica il cap DOMS: per una zona soggetta a DOMS con intensità superiore
 * a `DOMS_CAP_INTENSITY` ritorna il cap, altrimenti l'intensità originale.
 */
function applyDomsCap(zone, intensity) {
    return isDomsZone(zone) && intensity > exports.DOMS_CAP_INTENSITY
        ? exports.DOMS_CAP_INTENSITY
        : intensity;
}
/**
 * Intensità originale minima (prima del cap) da cui una zona DOMS genera
 * l'alert DOMS_CAP.
 */
exports.DOMS_ALERT_MIN_INTENSITY = 4;
/** La complaint su zona DOMS genera l'alert DOMS_CAP? */
function isDomsCapAlert(zone, intensity) {
    return isDomsZone(zone) && intensity >= exports.DOMS_ALERT_MIN_INTENSITY;
}
// ─── Incoerenza Body Map ↔ Hooper ────────────────────────────────────────────
/**
 * Intensità minima di una complaint da cui si verifica l'incoerenza col
 * questionario Hooper (dolore muscolare soggettivo elevato).
 */
exports.COMPLAINT_MIN_INTENSITY = 3;
/**
 * Punteggio `muscleSoreness` Hooper da cui, in presenza di una complaint con
 * intensità >= `COMPLAINT_MIN_INTENSITY`, scatta il warning di incoerenza.
 */
exports.HOOPER_SORENESS_ALERT_MIN = 5;
// ─── Trigger 1: High intensity ───────────────────────────────────────────────
/** Intensità minima (su qualsiasi zona) che genera l'alert HIGH_INTENSITY. */
exports.HIGH_INTENSITY_MIN = 4;
/** La complaint ha intensità da alert HIGH_INTENSITY? */
function isHighIntensity(intensity) {
    return intensity >= exports.HIGH_INTENSITY_MIN;
}
// ─── Trigger 2: Diffusione (multiple new zones) ──────────────────────────────
/** Numero minimo di zone segnalate nella compilazione corrente. */
exports.SPREAD_MIN_ZONES = 3;
/** Numero minimo di zone nuove (non presenti negli ultimi giorni) tra quelle segnalate. */
exports.SPREAD_MIN_NEW_ZONES = 2;
// ─── Trigger 3: Persistenza ───────────────────────────────────────────────────
/** Intensità minima di una zona perché conti ai fini della persistenza. */
exports.PERSISTENCE_MIN_INTENSITY = 2;
/** Giorni consecutivi (inclusa la compilazione corrente) che definiscono la persistenza. */
exports.PERSISTENCE_CONSECUTIVE_DAYS = 3;
/** L'intensità della zona conta ai fini del trigger di persistenza? */
function isPersistentIntensity(intensity) {
    return intensity >= exports.PERSISTENCE_MIN_INTENSITY;
}
// ─── Suggerimento apertura infortunio ────────────────────────────────────────
/**
 * Intensità (HIGH_INTENSITY o PERSISTENCE) da cui l'alert suggerisce
 * l'apertura di un infortunio.
 */
exports.SUGGEST_INJURY_INTENSITY = 5;
/** L'intensità del payload dell'alert suggerisce apertura infortunio? */
function suggestsInjuryIntensity(intensity) {
    return intensity === exports.SUGGEST_INJURY_INTENSITY;
}
